export const CHECKOUT_LABELS = 'checkout.bagPage';
const signinCtaBannerSignin = 'lbl_signin_cta_banner_signin';

const SignInCTABannerLabels = {
  checkout: {
    bagPage: { [signinCtaBannerSignin]: 'Sign in' },
  },
};

export default SignInCTABannerLabels;
